import React from "react"
import PropTypes from "prop-types"
import Radium, { keyframes } from "higher-order-components/configured-radium/"
import { childParser } from "containers/utilities"
import { FixedBar } from "containers"
import buildStyles from "./Build.less"
import classnames from "classnames"
import { A, StarIcon } from "AtomicComponents"
import { Disclaimer } from "AtomicContainers"

/* Singularity Bar Component. */
const SingularityBar = ({
  src,
  summary,
  compact,
  nameplate,
  grade,
  hidden,
  includeSafetyModel,
  price,
  disclaimer,
  children,
  gtmEvents,
  innerRef,
  components
}) => {
  const currentPrice = ((price || {}).data || [])[0] || {}
  return (
    <div data-test="singularity-bar">
      <FixedBar innerRef={innerRef}>
        {!summary ? (
          <div
            style={
              styles.left // Display nothing here if it reaches the summary step
            }>
            {!summary && <img style={styles.vehicle} src={src} />}
            {compact &&
              !summary && (
                <div
                  style={{
                    textTransform: "uppercase",
                    flexBasis: "100%",
                    padding: ".125em 0 0",
                    fontWeight: 600
                  }}>
                  {nameplate}
                </div>
              )}
            <div style={styles.price}>
              {!hidden &&
                !currentPrice.price &&
                !summary && (
                  <span style={[styles.hidden, styles.animate]}>{currentPrice.message}</span>
                )}
              {((!hidden && !!currentPrice.price) || (compact && summary)) && (
                <div style={styles.grade}> {grade} </div>
              )}
              {((!hidden && !!currentPrice.price) || (compact && summary)) && (
                <div style={styles.divider} />
              )}
              {((!hidden && !!currentPrice.price) || (compact && summary)) && (
                <div style={styles.animate}>
                  <div style={styles.small}>
                    <small>RRP FROM</small>
                  </div>
                  <span style={styles.priceValue}>
                    <div style={{ whiteSpace: "noWrap" }}>
                      <A
                        withoutStyle
                        style={{ fontSize: "26px" }}
                        onClick={(event) => {
                          if (event && event.target && event.target.querySelector('button')) {
                            event.target.querySelector('button').click()
                          }
                        }}>
                        <sup style={{ lineHeight: 0.5, fontSize: "12px" }}>$</sup>
                        {!!currentPrice.price && includeSafetyModel ? currentPrice.safetyModelPrice.toLocaleString() : currentPrice.price.toLocaleString()}
                        <Disclaimer Icon={StarIcon}>
                          {currentPrice.disclaimer}
                        </Disclaimer>
                      </A>
                    </div>
                  </span>
                </div>
              )}
            </div>
          </div>
        ) : (
          <div />
        ) // This div is to ensure there's alway a div rendered here in the summary step where we display nothing, just to keep the CTA button on the right
        }
        <div className={classnames({
          [buildStyles.ButtonsInside]: true
        })}>{childParser({ children, components })}</div>
      </FixedBar>
    </div>
  )
}

SingularityBar.propTypes = {
  summary: PropTypes.bool,
  children: PropTypes.node,
  components: PropTypes.array,
  src: PropTypes.string,
  hidden: PropTypes.bool,
  innerRef: PropTypes.func,
  compact: PropTypes.bool,
  nameplate: PropTypes.string,
  grade: PropTypes.string,
  price: PropTypes.shape({
    disclaimer: PropTypes.string,
    message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    price: PropTypes.number
  })
}

export default Radium(SingularityBar)

const dropOutKeyframes = keyframes({
  from: {
    opacity: 0,
    top: ".5em"
  },
  to: {
    opacity: 1,
    top: 0
  }
})

const styles = {
  left: {
    display: "flex",
    marginLeft: "1em",
    flexWrap: "wrap"
  },
  right: {
    display: "flex",
    flex: "1 0 50vw",
    justifyContent: "flex-end",
    "@media (min-width: 768px)": {
      display: "flex",
      minWidth: '360px',
      flex: 'none',
      justifyContent: "space-between",
    }
  },
  vehicle: {
    display: "none",
    "@media (min-width: 768px)": {
      width: "auto",
      height: "4em",
      display: "block",
      margin: "auto 1em auto 0"
    }
  },
  hidden: {
    color: "#999",
    fontWeight: 600,
    textTransform: "uppercase",
    fontSize: "90%",
    letterSpacing: ".2em"
  },
  grade: {
    color: "#999",
    fontWeight: 600,
    textTransform: "uppercase",
    fontSize: "90%",
    letterSpacing: ".2em",
    maxWidth: "200px",
    "@media (max-width: 768px)": {
      display: "none"
    }
  },
  divider: {
    display: "inline-block",
    width: "1px",
    height: "2.4em",
    margin: "0 1em",
    verticalAlign: "middle",
    background: "#d5d5d5",
    "@media (max-width: 768px)": {
      display: "none"
    }
  },
  price: {
    display: "flex",
    alignItems: "center"
  },
  small: {
    marginBottom: ".25em"
  },
  priceValue: {
    fontSize: "1.6em",
    fontWeight: "300"
  },
  /**
   * Radium x Safari keyframe animation bug
   * @todo find a solution to keyframe animations not triggering on Safari
  */
  animate: {
    // animation: 'x .666s forwards',
    // animationName: dropOutKeyframes,
    // opacity: 0,
    position: "relative"
  }
}



// WEBPACK FOOTER //
// ./src/containers/build/singularity-bar.jsx